import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { IClient } from "./type.ts";

type useClientParams = {
  id: string;
};

export const useClient = (params: useClientParams) => {
  const { token } = useAuth();
  const { id } = params;

  const fetch = useFetch();

  const { data, isFetching, isError, error } = useQuery<
    IClient | null,
    Error,
    IClient
  >({
    queryKey: ["client", id],
    enabled: !!id,
    queryFn: () =>
      fetch<IClient>(`${Urls.ClientById}`, {
        method: "GET",
        slug: {
          id
        }
      }, true, token),
    // gcTime: 0,
    // staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting client");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching,
  };
};
